// removed by extract-text-webpack-plugin
module.exports = {"KeyStats":"src-components-SuccessStories-KeyStats----KeyStats-module---KeyStats---AW8-J","KeyStats__wrapper":"src-components-SuccessStories-KeyStats----KeyStats-module---KeyStats__wrapper---1fBYp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuccessStories/KeyStats/KeyStats.module.scss
// module id = 746
// module chunks = 168707334958949